import { IJobEntry, JobType } from '../../../../contentful/types/IJob';

export function searchJobs({
	jobs,
	query,
	employerName,
	type,
}: {
	jobs: IJobEntry[];
	query?: string;
	employerName?: string;
	type?: JobType[];
}) {
	return jobs.filter((job) => {
		if (type?.length && !type.includes(job.fields.type as JobType)) {
			return false;
		}

		if (employerName && employerName !== job.fields.employerName) {
			return false;
		}

		if (
			query &&
			!job.fields.title.toLowerCase().includes(query.toLowerCase())
		) {
			return false;
		}

		return true;
	});
}
